module.exports = __webpack_public_path__ + "static/media/daon.6c1af1da.jpeg";